import { IBaseResponseData, ICommittee } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of committees from the `/committee` endpoint.
 */
export interface ICommitteeResponse extends IBaseResponseData {
  committees: ICommittee[]
}
